import { dataFile } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFile = /*#__PURE__*/createIcon(dataFile)
export default IconFile
